"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5975 5.4693h-6.7172c-.6808-.9064-1.7645-1.4927-2.9854-1.4927-2.061 0-3.7318 1.6707-3.7318 3.7317s1.6708 3.7318 3.7318 3.7318c1.3812 0 2.5873-.7504 3.2325-1.8659h1.6202l1.1196-1.1195 1.1195 1.1195 1.1195-1.1195 1.1196 1.1195h1.1195l1.4913-1.8659-2.2391-2.239zM8.8877 7.707c0 .5523-.4477 1-1 1s-1-.4477-1-1c0-.5522.4477-1 1-1s1 .4478 1 1z"
  }), _react.default.createElement("path", {
    d: "m2 21.062 3.2142-.9643a1.0002 1.0002 0 0 1 .5733-.0004l6.5851 1.9653a1.9604 1.9604 0 0 0 1.361-.0889l6.8702-3.0721A2.3593 2.3593 0 0 0 22 16.7477c0-1.5557-1.4793-2.6856-2.9802-2.2762l-2.8287.7714a2.3857 2.3857 0 0 0-1.9471-1.5285l-5.7816-.6979a2.283 2.283 0 0 0-1.1733.1682l-2.4448 1.0477a1 1 0 0 1-.745.0172L2 13.4624v2.136l1.397.5239a3.0004 3.0004 0 0 0 2.2351-.0516l2.4448-1.0478a.2855.2855 0 0 1 .1458-.0209l5.7817.6979a.3854.3854 0 0 1-.0462.768H10v2h3.9582c.8476 0 1.5804-.4383 2.0027-1.0891l3.5852-.9778a.3593.3593 0 0 1 .2412.6749l-6.8568 3.066-6.571-1.9611a3.0005 3.0005 0 0 0-1.72.0012L2 18.9739v2.0881z"
  })];
};

exports.default = _default;